import React from 'react';
import { Divider, Grid, Typography, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import OrderHandle from '../../assets/SvgIonReorderTwo';
import NavIcon from '../../assets/SvgEvaArrowIosBackFill';
import Theme from '../ui/Theme';
import { getDoseDetails } from '../../redux/actions/DealershipActions';
import Image from '../common/Image';

const useStyles = makeStyles(() => ({
  content: {
    padding: '16px 16px 16px 8px',
    left: 'calc(50% - 391px/2)',
    background: '#FAFAFA',
    cursor: 'pointer',
  },
  dividerStyle: {
    width: '21vw',
    marginTop: '4%',
  },

  highlightItem: {
    padding: '16px 16px 16px 8px',
    left: 'calc(50% - 391px/2)',
    background: '#F4F4F4',
    borderLeft: `4px solid ${Theme.palette.primary.main}`,
    cursor: 'pointer',
  },
  orderHandleIcon: {
    width: '20px',
    height: '20px',
    marginTop: '34px',
  },
  sourceImage: {
    width: '28px',
    height: '28px',
    marginTop: '3px',
    border: '1px solid #F4F4F4',
    boxSizing: 'border-box',
    borderRadius: '36px',
  },
  sourceSubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  sourceTextHolder: {
    padding: '0px 16px 0px 0px',
    width: '295px',
    marginLeft: '4%',
  },
  sourceText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    display: 'flex',
    alignItems: 'center',
    color: '#121212',
    opacity: '0.9',
    marginTop: '4px',
  },
  topSubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    alignItems: 'center',
    color: '#000000',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
const CardDailyDose = (props) => {
  const classes = useStyles();
  const doseDetails = useSelector((state) => state.getDoseDetails.doseDetails);
  const dispatch = useDispatch();
  const { doses } = props;
  let len = '';
  if (props.doses) {
    if (props.doses.sources) {
      len = props.doses.sources.length - 1;
    }
  }
  const updateDoseDetails = () => {
    dispatch(getDoseDetails(props.doses));
  };
  const showDoseCount = () => {
    if (doses) {
      if (doses.sources) {
        if (doses.sources.length === 1) {
          return doses.sources[0].name;
        }
        if (doses.sources.length > 1) {
          return `${doses.sources[0].name} and ${len} others `;
        }
      }
      return '';
    }
    return '';
  };
  const getImageSrc = () => {
    if (props.doses) {
      if (props.doses.sources) {
        if (props.doses.sources.length > 0) {
          return props.doses.sources[0].thumbnail;
        }
        return '';
      }
      return '';
    }
    return '';
  };
  return (
    <Grid
      value={props.doses}
      container
      direction="row"
      justifyContent="center"
      alignContent="center"
      className={props.doses?.id === doseDetails?.id ? classes.highlightItem : classes.content}
      onClick={updateDoseDetails}
    >
      <Grid item xs={1}>
        <OrderHandle className={classes.orderHandleIcon} />
      </Grid>
      <Grid item xs={11}>
        <Grid container direction="column">
          <Grid item>
            <Grid container direction="row" justifyContent="space-between">
              <Grid item style={{ width: '19vw' }}>
                <Typography className={classes.topSubText}>{props.doses?.title}</Typography>
                <Divider
                  style={{
                    marginTop: '12px',
                    marginBottom: '6px',
                    width: '21vw',
                  }}
                />
              </Grid>

              <Grid item>
                <NavIcon />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="row">
              <Grid item>
                <Image src={getImageSrc()} alt="Logo" className={classes.sourceImage} />
              </Grid>

              <Grid item>
                <Grid container direction="column" alignContent="flex-start" className={classes.sourceTextHolder}>
                  <Grid item>
                    <Typography className={classes.sourceSubText}>
                      {props.doses?.readingTime} min {doses?.type} from{' '}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.sourceText}>{showDoseCount()}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CardDailyDose;
